export default defineAppConfig({
  ui: {
    colors: {
      primary: "green",
      neutral: "gray",
    },
    // select: {
    //   rounded: "rounded-xl",
    //   color: {
    //     white: {
    //       outline: "shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-2 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400",
    //     },
    //   },
    //   default: {
    //     size: "lg",
    //     color: "white",
    //     variant: "outline",
    //     loadingIcon: "i-heroicons-arrow-path-20-solid",
    //     trailingIcon: "i-heroicons-chevron-down-20-solid",
    //   },
    // },
    // notifications: {
    //   container: "flex justify-center px-4 sm:px-6 py-6 space-y-3 overflow-y-auto flex-col items-center",
    //   position: "bottom-0 top-auto",
    //   width: "w-full sm:w-full w-dvw justify-center",
    // },
    // notification: {
    //   padding: "p-2",
    //   inner: "w-fit flex-1",
    //   wrapper: "w-fit pointer-events-auto",
    //   title: "text-xs text-center font-regular text-white",
    //   description: "text-xs text-center font-thin text-white",
    //   container: "relative overflow-hidden bg-primary-500",
    //   actions: "flex items-center gap-2 mt-3 flex-shrink-0 text-white",
    //   default: {
    //     color: "green",
    //     icon: null,
    //     timeout: 3000,
    //     closeButton: {
    //       icon: "i-heroicons-x-mark-solid",
    //       color: "white",
    //       variant: "link",
    //       padded: false,
    //     },
    //     actionButton: {
    //       size: "xs",
    //       color: "white",
    //     },
    //   },
    // },
    // button: {
    //   rounded: "rounded-full",
    //   padding: {
    //     lg: "px-4 py-2.5",
    //   },
    //   color: {
    //     gray: {
    //       solid: "shadow-sm text-gray-700 dark:text-gray-200 bg-gray-100 hover:bg-gray-100 disabled:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700/50 dark:disabled:bg-gray-800 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
    //     },
    //   },
    //   default: {
    //     size: "lg",
    //   },
    // },
    // divider: {
    //   wrapper: {
    //     horizontal: "py-5 w-full flex-row",
    //   },
    // },
    form: {
      base: "w-full",
    },
    formField: {
      slots: {
        container: "w-full",
      },
    },
    input: {
      slots: {
        root: "relative inline-flex items-center w-full",
        base: "rounded-[0.6rem]",
      },
      variants: {
        size: {
          lg: {
            base: "px-3.5 py-2.5 text-sm gap-2",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "outline",
          class: "ring-2 ring-inset",
        },
      ],
      defaultVariants: {
        size: "lg",
        color: "primary",
        variant: "outline",
      },
    },

    textarea: {
      slots: {
        root: "relative inline-flex items-center w-full",
        base: "rounded-[0.6rem]",
      },
      variants: {
        size: {
          lg: {
            base: "px-3.5 py-2.5 text-sm gap-2",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "outline",
          class: "ring-2 ring-inset",
        },
      ],
      defaultVariants: {
        size: "lg",
        color: "primary",
        variant: "outline",
      },
    },

    inputMenu: {
      slots: {
        root: "relative inline-flex items-center w-full",
        base: "rounded-[0.6rem]",
      },
      variants: {
        size: {
          lg: {
            base: "px-3.5 py-2.5 text-sm gap-2",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "outline",
          class: "ring-2 ring-inset",
        },
      ],
      defaultVariants: {
        size: "lg",
        color: "primary",
        variant: "outline",
      },
    },

    inputNumber: {
      slots: {
        root: "relative inline-flex items-center w-full",
        base: "rounded-[0.6rem]",
      },
      variants: {
        size: {
          lg: {
            base: "px-3.5 py-2.5 text-sm gap-2",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "outline",
          class: "ring-2 ring-inset",
        },
      ],
      defaultVariants: {
        size: "lg",
        color: "primary",
        variant: "outline",
      },
    },

    selectMenu: {
      slots: {
        base: "rounded-[0.6rem] relative inline-flex items-center w-full",
      },
      variants: {
        size: {
          lg: {
            base: "px-3.5 py-2.5 text-sm gap-2",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "outline",
          class: "ring-2 ring-inset",
        },
      ],
      defaultVariants: {
        size: "lg",
        color: "primary",
        variant: "outline",
      },
    },
    card: {
      variants: {
        variant: {
          soft: {
            root: "bg-white divide-none",
          },
        },
      },
      defaultVariants: {
        variant: "soft",
      },
    },
    avatar: {
      defaultVariants: {
        size: "lg",
      },
    },
    button: {
      defaultVariants: {
        size: "lg",
      },
    },
    table: {
      slots: {
        th: "px-3.5 py-3.5 text-[#8D8D8D] bg-[#F0EFF0]",
        base: "rounded-2xl border-1 border-[#F0EFF0]",
      },
    },
    modal: {
      slots: {
        header: "min-h-14 sm:px-4",
      },
      variants: {
        fullscreen: {
          false: {
            content: "max-w-3xl",
          },
        },
      },
    },
    navigationMenu: {
      slots: {
        label: "text-[#A9A9A9]",
        separator: "px-6 h-0",
      },
    },
    radioGroup: {
      variants: {
        variant: {
          table: {
            item: "items-center first-of-type:rounded-t-xs last-of-type:rounded-b-xs",
          },
        },
      },
    },
  },
});
